import React from 'react';
import firebase from 'firebase';
import HCard from './HCard';

class Overview extends React.Component {

  state = { 
    userCount:0,
    businessCount:0,
    promotionCount:0,
    couponCount:0,
  };

  componentDidMount() {
    this.getUsers();
    this.getPromotions();
    this.getCoupons();
  }

  getUsers () {
    var items = firebase.database().ref('user');
    var userCount = 0;
    var businessCount = 0;
    items.once('value', (data) => {
      var object = data.val();
      for (var key in object) {
        if (object.hasOwnProperty(key) && object[key].type === 'user') {
          userCount++;
        } else if (object.hasOwnProperty(key) && object[key].type === 'business') {
          businessCount++;
        }
      }
      this.setState({userCount:userCount, businessCount:businessCount})
    });
  }

  getPromotions () {
    var items = firebase.database().ref('promotions');
    var promotionCount = 0;
    items.once('value', (data) => {
      var object = data.val();
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          promotionCount++;
        }
      }
      this.setState({promotionCount:promotionCount})
    });
  }

  getCoupons () {
    var items = firebase.database().ref('coupons');
    var couponCount = 0;
    items.once('value', (data) => {
      var object = data.val();
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          couponCount++;
        }
      }
      this.setState({couponCount:couponCount})
    });
  }

  render() {
    return (
      <section className='overview'>
        <div className='row'>
          <div className='col-sm-3'>
            <HCard iconName='users' backgroundColor='tealBG' label='users' number={this.state.userCount} />
          </div>
          <div className='col-sm-3'>
            <HCard iconName='building' backgroundColor='amberBG' label='businesses' number={this.state.businessCount} />
          </div>
          <div className='col-sm-3'>
            <HCard iconName='tags' backgroundColor='pinkBG' label='promotions' number={this.state.promotionCount} />
          </div>
          <div className='col-sm-3'>
            <HCard iconName='barcode' backgroundColor='cyanBG' label='coupons' number={this.state.couponCount} />
          </div>
        </div>
      </section>
    )
  }
}

export default Overview;


// WEBPACK FOOTER //
// ./src/components/Overview.js